import React from "react";
import { useTranslation } from "react-i18next";
import expectedQualityRow from "../ResultWidget/rows/expectedQuality/expectedQuality";
import Alert from "../Alert/Alert";

import { TestResults } from "../../types";

import { getBestEdge } from "../../util/getBestEdge";

export default function SummaryWidget({
  results
}: {
  results?: TestResults[];
}) {
  if (!results) return null;
  const { t: translate } = useTranslation();

  const bestEdge = getBestEdge(results);

  if (bestEdge) {
    const bestEdgeQuality = expectedQualityRow.getValue(bestEdge);

    return (
      <div>
        <Alert variant="success">
          <span>
            {translate("expectedCallQuality")}{" "}
            <strong>{bestEdgeQuality}</strong>
          </span>
        </Alert>
      </div>
    );
  } else {
    return null;
  }
}
